import { jsx as a, jsxs as i } from "react/jsx-runtime";
import e from "./contact-card-reseller.module.less.js";
const m = ({
  companyName: s,
  streetAdress: d,
  postalCode: o,
  postalLocality: l,
  phone: n,
  websiteUrl: c
}) => {
  const r = `${o} ${l ? ", " + l : ""}`.trim();
  return /* @__PURE__ */ a("div", { className: e.wrapper, children: /* @__PURE__ */ i("div", { className: e.contentWrapper, children: [
    /* @__PURE__ */ i("div", { className: e.identificationSection, children: [
      /* @__PURE__ */ a("p", { className: [e.name, "body-base bold mb-0"].join(" "), children: s }),
      d && /* @__PURE__ */ a("p", { className: [e.addressLine, "body-s my-0"].join(" "), children: d }),
      r && /* @__PURE__ */ a("p", { className: [e.addressLine, "body-s my-0"].join(" "), children: r })
    ] }),
    /* @__PURE__ */ i("div", { className: e.contactSection, children: [
      c && /* @__PURE__ */ a("a", { href: c, className: ["body-s mb-0", e.link].join(" "), children: c }),
      n && /* @__PURE__ */ a("a", { href: `tel:${n}`, className: ["body-s mb-0", e.link].join(" "), children: n })
    ] })
  ] }) });
}, N = (s) => /* @__PURE__ */ a("div", { className: "space-my-sm", children: /* @__PURE__ */ a(m, { ...s }) });
export {
  m as ContactCardReseller,
  N as ContactCardResellerContent,
  m as default
};
